import { useQuery, useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { noop, getUrl } from '../lib/serviceHelpers';
import { getAccessToken } from '../lib/ringcentral/auth';

// The server reads `start` and `end` (meetingsController.getInvites) and
// falls back to the current month when they are missing. These were sent as
// startDt/endDt until 2026-10-29, so the calendar could only ever show the
// current month whatever month was on screen.
export const useFetchCalendar = (startDt, endDt, userId, opts = {}) => {
  return useQuery(
    ['calendar', { startDt, endDt, userId }],
    async () => {
      const url = getUrl('/meetings/invites', {
        start: startDt,
        end: endDt,
        userId,
      });
      const res = await axios.get(url);
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 5000,
      ...opts,
    },
  );
};

export const useCreateCall = (callback, opts = {}) => {
  return useMutation(
    async (inviteId) => {
      const rcToken = getAccessToken();
      const res = await axios.get(`/meetings/invites/join/${inviteId}`, {
        headers: rcToken ? { 'x-rc-access-token': rcToken } : {},
      });
      return res.data;
    },
    { ...opts, onSuccess: callback || noop },
  );
};

export const useUpsertMeetingInvite = (callback, opts = {}) => {
  return useMutation(
    async ({ meetingInviteId, payload }) => {
      const res = await axios({
        url: `/meetings/invites${meetingInviteId ? `/${meetingInviteId}` : ''}`,
        method: meetingInviteId ? 'put' : 'post',
        data: { ...payload },
      });

      return res.data;
    },
    { ...opts, onSuccess: callback || noop },
  );
};

export const useDeleteMeetingInvite = (callback, opts = {}) => {
  return useMutation(
    async (meetingInviteId) => {
      const res = await axios({
        url: `/meetings/invites/${meetingInviteId}`,
        method: 'delete',
      });

      return res.data;
    },
    { ...opts, onSuccess: callback || noop },
  );
};
